import { ArrowTopRightOnSquareIcon } from "@heroicons/react/24/outline";
import { FC } from "react";
import { IEsimDiagnosticsDevice } from "../../../interfaces/esim/EsimDiagnostics.types";
import { formatDateTimeSq } from "../../../utils/esim/format";
import SuperAdmin from "../../users/permissions/SuperAdmin";

const Row: FC<{ label: string; value?: string | null }> = ({ label, value }) => (
  <div className="flex justify-between gap-4 py-1 border-b last:border-b-0">
    <span className="text-sm text-gray-500">{label}</span>
    <span className="text-sm font-medium text-gray-800 text-right break-all">
      {value || "—"}
    </span>
  </div>
);

interface DeviceCardProps {
  device: IEsimDiagnosticsDevice;
  subscriberStatus?: string | null;
}

const DeviceCard: FC<DeviceCardProps> = ({ device, subscriberStatus }) => {
  const network = [device.lastMcc, device.lastMnc].filter(Boolean).join(" / ");
  const imeiUrl = device.lastImei
    ? `https://www.imei.info/?imei=${encodeURIComponent(device.lastImei)}`
    : undefined;

  return (
    <div className="bg-white p-4 rounded-lg shadow-sm">
      <h3 className="text-sm font-semibold text-gray-700 mb-2">Pajisja & rrjeti</h3>
      <Row label="Statusi i abonentit" value={subscriberStatus} />
      <Row label="Teknologjia (RAT)" value={device.lastRat} />
      <Row label="Rrjeti (MCC/MNC)" value={network || null} />
      <Row
        label="Aktiviteti i fundit në rrjet"
        value={device.lastNetworkAttachUtc ? formatDateTimeSq(device.lastNetworkAttachUtc) : null}
      />
      <SuperAdmin>
        <div className="flex justify-between gap-4 py-1 border-b last:border-b-0 items-center">
          <span className="text-sm text-gray-500">IMEI (i fundit i njohur)</span>
          {device.lastImei ? (
            <span className="flex items-center gap-2 text-right">
              <span className="text-sm font-medium text-gray-800 break-all">
                {device.lastImei}
              </span>
              <a
                href={imeiUrl}
                target="_blank"
                rel="noopener noreferrer"
                title="Identifiko pajisjen në imei.info"
                className={`shrink-0 inline-flex items-center gap-1 text-xs
                  font-medium text-primary hover:underline`}
              >
                Identifiko
                <ArrowTopRightOnSquareIcon className="w-3.5 h-3.5" />
              </a>
            </span>
          ) : (
            <span className="text-sm font-medium text-gray-800">—</span>
          )}
        </div>
      </SuperAdmin>
    </div>
  );
};

export default DeviceCard;
